//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams, Routes, useLocation } from 'react-router-dom';

// import created components  :
import Background from '../../components/background/Background.jsx'
import WallyBanner from '../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />


// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

//MUI :
import Button from '@mui/material/Button';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import CheckIcon from '@mui/icons-material/Check';
import Modal from '@mui/material/Modal';
import InfoIcon from '@mui/icons-material/Info';
import StarIcon from '@mui/icons-material/Star';
import HelpIcon from '@mui/icons-material/Help';
import ImportantDevicesIcon from '@mui/icons-material/ImportantDevices';
import SurfingIcon from '@mui/icons-material/Surfing';
import FastForwardIcon from '@mui/icons-material/FastForward';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import SyncIcon from '@mui/icons-material/Sync';
import Alert from '@mui/material/Alert';

// API fetch
import axios from "axios";
import { baseURL, phpURL, appURL } from '../../config/api-config.js';

//Utils 
import setNumResa from '../../utils/set_num_resa.js'; //params : resaInfos

function Paiement() { // full page as component imported in router
    const navigate = useNavigate();
    const { idResa, idClient } = useParams(); //id of the selected resa, in url (as string)
    const location = useLocation();
    const { hash, pathname, search } = location;
    console.log(search);

    const [allInfos, setAllInfos] = useState();
    const [formules, setFormules] = useState();
    const [elevesList, setElevesList] = useState([]);
    const [creneauxList, setCreneauxList] = useState([]);
    const [confirmMode, setConfirmMode] = useState(/* pathname.split("/")[1] === "confirm-paiement" */);



    let allEleves = [];
    let allCreneaux = [];

    //// -- At first render :
    useEffect(() => {
        async function initFormules() { //we add this inner function to manage asynchrone
            let allFormules = await getFormules(); // get formules from DB ...
            setFormules(allFormules);
        } //end of async function
        initFormules(); //call the inner asnchrone function

        async function initResa() { //we add this inner function to manage asynchrone
            let resaInfos = await getResa(); // get resa infos from DB ...
            if (resaInfos.Client.id_client != parseInt(idClient) || resaInfos.match === false) {
                navigate("../error")
            }
            //console.log(resaInfos);

            setAllInfos(resaInfos);

        } //end of async function
        initResa(); //call the inner asnchrone function
    }, [idResa])
    //// --


    //// -- At allInfos loading:
    useEffect(() => {
        if (allInfos) {
            console.log(allInfos);
            allInfos.CreneauEleves.map((creneauEleve) => { // for every line in CreneauEleve Table...

                //// -- We want a list of eleves

                // if eleve not in the list already...
                if (allEleves.filter((eleve) => eleve.id === creneauEleve.Eleve.id_eleve).length === 0) {
                    allEleves.push({  //... we add this eleve to the list, with his infos reformated for global state "Eleves" 
                        id: creneauEleve.Eleve.id_eleve,
                        prenom: creneauEleve.Eleve.prenom,
                        age: creneauEleve.Eleve.age
                    });
                    allEleves.sort((e1, e2) => e1.id > e2.id ? 1 : -1); // We sort the list of eleves, as they "arrive" in disorder
                }

                allCreneaux.push({
                    eleve_id: creneauEleve.Eleve.id_eleve,
                    date: creneauEleve.Creneau.date,
                    horaire: creneauEleve.Creneau.horaire,
                });

            });// end of map

            setElevesList(allEleves);
            setCreneauxList(allCreneaux);
            setConfirmMode(allInfos.solde === 0)

        }

    }, [allInfos])
    //// --


    async function getFormules() { // Get formules from DB
        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/formule`,
            });
            const formules = response.data;
            return formules;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    async function getResa() { // Get Resa Infos from DB (request with joins...)

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/resa/${idResa}`,
            });
            //console.log(response);
            const infos = response.data;
            return infos;
        } catch (err) {
            console.error(err);
            return null;
        }
    }






    function getFormulesInfos(eleve) {
        let nbcours = creneauxList.filter((creneau) => creneau.eleve_id === eleve.id).length;
        let currentFormule = formules.find((f) => f.nb_cours === nbcours);
        //console.log(nbcours, formules);
        return currentFormule.nom_formule + ", " + currentFormule.tarif + ",00€"
    }

    function getBilling(client) {
        return `<?xml version="1.0" encoding="utf-8"?><Billing><Address><FirstName>${client.prenom}</FirstName><LastName>${client.nom}</LastName><Address1>${client.adresse_vacances}</Address1><ZipCode>49300</ZipCode><City>Cholet</City><CountryCode>250</CountryCode></Address></Billing>`
    }

    function getShoppingCart() {
        return `<?xml version="1.0" encoding="utf-8"?><shoppingcart><total><totalQuantity>${elevesList.length}</totalQuantity></total></shoppingcart>`
    }



    return (
        <div className="bg-relative">
            <Background ind={1} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">
                    <WallyBanner size={"small"} />

                    {allInfos && // display infos only when promise is fullfilled

                        <div className="paiement">

                            {confirmMode === true ?
                                <h1>La banque a confirmé votre paiement</h1>
                                :
                                <h1>Payez votre réservation en ligne</h1>
                            }

                            <div className="paiement-top">



                                <div className="paiement-left">

                                    <div className="paiement-left-client">
                                        <h4>{allInfos.Client.prenom} {allInfos.Client.nom}</h4>
                                        <p>{allInfos.Client.tel}</p>
                                        <p>{allInfos.Client.email}</p>
                                    </div>

                                    <div className="paiement-left-resa">
                                        <p>{"Réservation : " + setNumResa(allInfos)}</p>
                                    </div>

                                </div>
                                <div className="paiement-right">
                                    {
                                        elevesList.map((eleve) => (
                                            <div className="paiement-right-eleve">
                                                <p>{eleve.prenom}</p>
                                                <p>{getFormulesInfos(eleve)}</p>
                                            </div>
                                        ))
                                    }
                                    {
                                        allInfos.coupon > 0 ?
                                            <h5>{"Réduction appliquée : " + allInfos.coupon + "%"}</h5>
                                            : null
                                    }
                                </div>

                            </div>
                            {confirmMode === true ?
                                <div className="paiement-bottom">



                                    <h4>{"Vous avez payé : " + Math.round((100 - allInfos.coupon) / 100 * allInfos.total) + ",00€"}</h4>
                                    <p>Vous allez recevoir un email de confirmation.</p>
                                    <p>Merci à vous, votre paiement a bien été pris en compte. A très vite pour vos sessions avec Wally Glisse, plage du Lion à Lacanau.</p>

                                </div>
                                :
                                <div className="paiement-bottom">



                                    <h4>{"Total à payer : " + Math.round((100 - allInfos.coupon) / 100 * allInfos.total) + ",00€"}</h4>


                                    <form method="POST" action={phpURL + "nestor/paiement.php"}>
                                        <input type="hidden" name="post_total" value={Math.round((100 - allInfos.coupon) / 100 * allInfos.total)} />
                                        <input type="hidden" name="post_numResa" value={setNumResa(allInfos)} />
                                        <input type="hidden" name="post_email" value={allInfos.Client.email} />
                                        <input type="hidden" name="post_idResa" value={idResa} />
                                        <input type="hidden" name="post_idClient" value={idClient} />
                                        <input type="hidden" name="post_baseURL" value={baseURL} />
                                        <input type="hidden" name="post_appURL" value={appURL} />
                                        <input type="hidden" name="post_billing_firstname" value={allInfos.Client.prenom} />
                                        <input type="hidden" name="post_billing_lastname" value={allInfos.Client.nom} />
                                        <input type="hidden" name="post_shoppingcart" value={String(elevesList.length)} />


                                        <Button
                                            type="submit"
                                            className="paiement-bouton"
                                            variant="contained"
                               /*  onClick={_ => goPay()} */>
                                            Payer en ligne
                                    </Button>

                                    </form>
                                </div>
                            }
                        </div>
                    }
                </div>
            </main>

        </div>
    );
}

export default Paiement;